// Formato esperado por endpoints /telefonia/softphone/qr|link: codOperadora-cCiudad-contrato
// Los tres valores vienen del endpoint de Consumo (paquete Telefonia).
export const buildContratoId = ({ contrato, cCiudad, codOperadora }) => {
    if (!contrato || !cCiudad || !codOperadora) return null;
    return `${codOperadora}-${cCiudad}-${contrato}`;
};
